import React from 'react';

const ToastContext = React.createContext({ push: (...args) => console.log("Toast provider missing, message: ", args) }); // eslint-disable-line no-console

export default ToastContext;
